import React from 'react';
import {
  Produktbaustein,
  If,
  Message,
  toMoney,
  findValueById,
  FormSelect,
  useUpdateAndBerechneOnChange,
  appActions,
} from 'ion-lib';
import { useSelector, useDispatch } from 'react-redux';
import i18next from 'i18next';
import { Accordion } from 'react-bootstrap';

const Zusatzvereinbarung = ({
  handleChange,
  nberabattWert,
}) => {
  const berechneOnChange = useUpdateAndBerechneOnChange(0);
  const dispatch = useDispatch();
  const florianrabatt = useSelector((state) => state.daten.florianrabatt);
  const nberabatt = useSelector((state) => state.daten.nberabatt);
  const zahlweise = useSelector((state) => state.daten.zahlweise);
  const zielgruppenrabatt = useSelector((state) => state.daten.zielgruppenrabatt);

  return (
    (florianrabatt.relevant || nberabatt.relevant || zielgruppenrabatt.relevant)
    && (
      <Accordion
        className="mb-3 mt-3"
        alwaysOpen={false}
        defaultActiveKey={null}
      >
        <Accordion.Item>
          <Accordion.Header>
            Zusatzvereinbarung
          </Accordion.Header>
          <Accordion.Body>
            <If predicate={florianrabatt.relevant}>
              <Produktbaustein
                title="Florianrabatt"
                tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.florianrabatt_tt')))}
                onChange={(value) => handleChange('daten.florianrabatt.value', value)}
                name="daten.florianrabatt.value"
                checkbox={florianrabatt}
              >
                <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.florianrabatt_beschreibung') }} />
              </Produktbaustein>
            </If>

            <If predicate={zielgruppenrabatt.relevant}>
              <Produktbaustein
                checkbox={false}
                title="Zielgruppenrabatt"
                tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.zielgruppenrabatt_tt')))}
                name="daten.zielgruppenrabatt"
                component={(
                  <FormSelect
                    {...zielgruppenrabatt}
                    className="ms-auto mb-0"
                    name="daten.zielgruppenrabatt.value"
                    onChange={berechneOnChange}
                  />
                )}
              >
                <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.zielgruppenrabatt_beschreibung') }} />
              </Produktbaustein>
            </If>

            <If predicate={nberabatt.relevant}>
              <Produktbaustein
                title="Rabatt bei positiver NBE"
                tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.nberabatt_tt')))}
                onChange={(value) => handleChange('daten.nberabatt.value', value)}
                name="daten.nberabatt.value"
                checkbox={nberabatt}
              >
                <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.nberabatt_beschreibung') }} />
              </Produktbaustein>

              <If predicate={nberabattWert.relevant}>
                <Message
                  show
                  dismissible={false}
                  text={`<p style="font-weight: 500; color: #000;">Der neue Preis beträgt ${toMoney(nberabattWert.value)} ${findValueById(zahlweise.valueSet, zahlweise.value)}.</p>`}
                  variant="danger"
                />
              </If>

              <If predicate={nberabatt.warning}>
                <Message
                  show
                  text={nberabatt.warning}
                  variant="dark"
                />
              </If>
            </If>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    )
  );
};

export default Zusatzvereinbarung;
